import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGmailRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.488 26h4.241V15.7l-6.06-4.545v13.027c0 1.006.816 1.818 1.819 1.818",
			fill: "#4285f4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.27 26h4.242a1.817 1.817 0 0 0 1.817-1.818V11.155L23.27 15.7",
			fill: "#34a853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.27 7.823V15.7l6.06-4.545V8.732c0-2.248-2.566-3.53-4.363-2.182",
			fill: "#fbbc04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.73 15.7V7.823L16 13.276l7.271-5.453V15.7l-7.27 5.453",
			fill: "#ea4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.67 8.732v2.423L8.729 15.7V7.823L7.032 6.55c-1.8-1.348-4.362-.066-4.362 2.182",
			fill: "#c5221f"
		})
	]
});
export default SvgGmailRegularIcon;
